import { DatabaseWrapper } from '../../../shared/databases/database.wrapper';
import { Database } from '../../../shared/databases/database';
import { DatabaseEnum } from 'src/app/shared/databases/databases.enum';
import { RepConnWrapper } from '../../repconn/repconn.wrapper';
import { ObjectWrapper } from 'src/app/shared/wrappers/object.wrapper';
import { Attribute } from 'src/app/shared/models/domain/attribute';

export class FacebookWrapper extends DatabaseWrapper {

	constructor(database: Database) {
		super(database);

		this.dbTyp_Id = DatabaseEnum.facebook.ID;
		this.name = DatabaseEnum.facebook.NAME;
		this.code = DatabaseEnum.facebook.CODE;
		this.equivalentTag = DatabaseEnum.facebook.EQUIVALENT_TAG;

		this.showLoadPropertiesTab = false;

		this.showDatabaseTab = false;
		this.showDDLOption = true;
		this.showViewDataTabOption = true;
		this.isNeedRedirectForTestDP = true;
		this.isShowObjProperties = true;
		this.disableTestDataPointButton = true;
    this.showDataDescription = false;
	}

	// validateRepConn(repConnWrapper: RepConnWrapper): void {
	// 	if (!repConnWrapper.repConn.conn.consumerKey.length) {
	// 		repConnWrapper.inValid_Cds.push('APP_ID');
	// 	}
	// 	if (!repConnWrapper.repConn.conn.accessToken.length) {
	// 		repConnWrapper.inValid_Cds.push('ACCESS_TOKEN');
	// 	}
	// 	if (!repConnWrapper.repConn.conn.consumerSecret.length) {
	// 		repConnWrapper.inValid_Cds.push('APP_SECRET');
	// 	}
	// 	if (repConnWrapper.repConn.conn.flagent_Id == -1) {
	// 		repConnWrapper.inValid_Cds.push('ESM00202');
	// 	}
	// }

	validateRepConn(repConnWrapper: RepConnWrapper): void {

		if (String(repConnWrapper.repConn.conn.batchSize) == 'null' ||
			String(repConnWrapper.repConn.conn.batchSize) == '') {
			repConnWrapper.inValid_Cds.push('ESM00671');
		} else if (String(repConnWrapper.repConn.conn.timeOut) == 'null' ||
			String(repConnWrapper.repConn.conn.timeOut) == '') {
			repConnWrapper.inValid_Cds.push('ESM00672');
		}


		if (repConnWrapper.repConn.conn.access_Token_Flg == 'Y') {
			if (repConnWrapper.repConn.conn.consumerKey == "") {
				repConnWrapper.inValid_Cds.push('CONS_KEY');
			}

			if (repConnWrapper.repConn.conn.consumerSecret == "") {
				repConnWrapper.inValid_Cds.push('CONS_SEC');
			}

			if (repConnWrapper.repConn.conn.url == "") {
				repConnWrapper.inValid_Cds.push('CBK_URL');
			}
		}
		if (repConnWrapper.repConn.conn.accessToken == "") {
			repConnWrapper.inValid_Cds.push('ACCESS_TOKEN');
		}
		if (repConnWrapper.repConn.conn.connType == "") {
			repConnWrapper.inValid_Cds.push('CONN_TYPE');
		}
		if (repConnWrapper.repConn.conn.flagent_Id == -1) {
			repConnWrapper.inValid_Cds.push('ESM00202');
		}
	}

	getAttributeColumns(objectWrapper: ObjectWrapper,
		attributes: Array<Attribute> = new Array<Attribute>(), component: any = null, hideRowSelection: boolean = true): Array<any> {
		return [
			this.attributeTabulator.getCheckBoxColumn(objectWrapper, hideRowSelection),
			this.attributeTabulator.getSrt_Order(),
			this.attributeTabulator.getAttr_Id(),
			this.attributeTabulator.getAttrNm(objectWrapper,component),
			this.attributeTabulator.getAttrDTyp_Id(objectWrapper, attributes, component),
			this.attributeTabulator.getAttrPrec(objectWrapper),
			this.attributeTabulator.getAttrScale(objectWrapper),
			this.attributeTabulator.getNotNullFlag(objectWrapper),
			this.attributeTabulator.getAttrKeyTyp_Id(objectWrapper),
			this.attributeTabulator.getDescription(objectWrapper),
		]
	}

	getSourceAttributeColumns(objectWrapper: ObjectWrapper = null, isComplex: boolean = false,
		isShowPIIColumn: boolean = false, isGoogleAnalytics: boolean = false, isEncryptedFlag: boolean = false, isMax: boolean = false, component: any): Array<any> {   // isEncode: boolean = false,
		return [
			this.attributeTabulator.getCheckBoxColumn(objectWrapper),
			this.attributeTabulator.getSrt_Order(),
			this.attributeTabulator.getAttr_Id(),
			this.attributeTabulator.getClevel(objectWrapper, isComplex),
			this.attributeTabulator.getAttrNm(objectWrapper,component),
			this.attributeTabulator.getAttrDTyp_Id(objectWrapper, objectWrapper.object.attributes, component),
			this.attributeTabulator.getAttrPrec(objectWrapper),
			this.attributeTabulator.getAttrScale(objectWrapper),
			this.attributeTabulator.getAttrPiiIdentifierFlag(objectWrapper, isShowPIIColumn),
			this.attributeTabulator.getEncryptedFlag(objectWrapper, isEncryptedFlag),
			this.attributeTabulator.getLnk_Attr_Id(objectWrapper),
			this.attributeTabulator.getLnk_Attr_Datatype(objectWrapper),
			this.attributeTabulator.getValid_Cd(objectWrapper, component),
		]
	}

	getDerivedAttributeColumns(objectWrapper: ObjectWrapper, component: any, isMax: boolean = false, attributes: Array<Attribute> = new Array<Attribute>(), isHiveNative: boolean = false,hideOrderBy): Array<any> {
		return [
			this.attributeTabulator.getCheckBoxColumn(objectWrapper),
			this.attributeTabulator.getSrt_Order(),
			this.attributeTabulator.getAttr_Id(),
			this.attributeTabulator.getAttrNm(objectWrapper,component),
			this.attributeTabulator.getAttrDTyp_Id(objectWrapper),
			this.attributeTabulator.getAttrPrec(objectWrapper),
			this.attributeTabulator.getAttrScale(objectWrapper),
			this.attributeTabulator.getMaxFlag(objectWrapper, isMax),
			this.attributeTabulator.getAttrPiiIdentifierFlag(objectWrapper, true),
			this.attributeTabulator.getOrderBy(objectWrapper, component,hideOrderBy),
			this.attributeTabulator.getPartitionflag(objectWrapper, isHiveNative),
			this.attributeTabulator.getAttrExprVal(objectWrapper, component),
			this.attributeTabulator.getValid_Cd(objectWrapper, component),
		]
	}
}
